// ---------------------------------------------- modules import
import { IAlbumState, AlbumAction, AlbumActionType } from "./common";

const initialState: IAlbumState = {
  loading: false,
  error: null
};

// ---------------------------------------------- the reducer
const albumReducer = (
  state = initialState,
  action: AlbumAction
): IAlbumState => {
  switch (action.type) {
    case AlbumActionType.ADD_ALBUM_BEGIN:
    case AlbumActionType.UPDATE_ALBUM_BEGIN:
    case AlbumActionType.DELETE_ALBUM_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case AlbumActionType.ADD_ALBUM_SUCCESS:
    case AlbumActionType.UPDATE_ALBUM_SUCCESS:
    case AlbumActionType.DELETE_ALBUM_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      };
    }
    case AlbumActionType.ADD_ALBUM_ERROR:
    case AlbumActionType.UPDATE_ALBUM_ERROR:
    case AlbumActionType.DELETE_ALBUM_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }
    default: {
      return state;
    }
  }
};

export default albumReducer;
